<template>
  <el-dialog :title="title" @closed="_closed" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="80%">
    <div style="padding: 20px;">
    <div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">任务ID：</span>
            <span>{{task.task_id}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">地点名称：</span>
            <span>{{task.location_name}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">工人姓名：</span>
            <span>{{task.worker_name}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">打卡时间：</span>
            <span>{{task.clock_in_time}}</span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">提交时间：</span>
            <span>{{task.submit_time || '-'}}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="detail-item">
            <span class="label">当前状态：</span>
            <el-tag :type="getStatusType(task.status)">{{ getStatusText(task.status) }}</el-tag>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-divider v-if="standardImageUrl || images.length > 0"></el-divider>

    <el-row :gutter="16" v-if="standardImageUrl || images.length > 0">
      <!-- 标准图片 - 左边 -->
      <el-col :span="12" v-if="standardImageUrl">
        <el-card>
          <template #header>
            <div class="card-header">标准清洁图片（基准图）</div>
          </template>
          <div class="image-container">
            <img :src="standardImageUrl" alt="标准清洁图片" class="detail-image">
          </div>
        </el-card>
      </el-col>
      <!-- 工人上传图片 - 右边 -->
      <el-col :span="12" v-if="images.length > 0">
        <el-card>
          <template #header>
            <div class="card-header">工人上传图片</div>
          </template>
          <div class="image-grid">
            <div v-for="(img, index) in images" :key="index" class="image-item">
              <img :src="img.image_url" alt="上传图片" class="detail-image">
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-divider></el-divider>

    <el-card>
      <template #header>
        <div class="card-header">AI审核结果</div>
      </template>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="detail-item">
            <span class="label">AI打分：</span>
            <span :class="task.ai_pass ? 'text-green' : 'text-red'">{{task.ai_score !== null ? task.ai_score + '分' : '-'}}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="detail-item">
            <span class="label">AI结论：</span>
            <span :class="task.ai_pass ? 'text-green' : 'text-red'">{{task.ai_score === null ? '-' : (task.ai_pass ? '合格' : '不合格')}}</span>
          </div>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="detail-item">
            <span class="label">AI原因：</span>
            <span>{{task.ai_reason || '-'}}</span>
          </div>
        </el-col>
      </el-row>

      <div class="margin-top" v-if="task.status === 1">
        <el-button type="warning" @click="triggerAiAudit" :loading="triggerLoading">重新触发AI审核</el-button>
      </div>
    </el-card>
 </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="_cancle">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      title: '', // 内置参数,误删
      visible: true, // 内置参数,误删
      taskId: 0,
      task: {},
      images: [],
      standardImageUrl: '',
      triggerLoading: false
    }
  },
  created() {
    console.log('[taskDetail] created, data =', this.data)
    if (this.data && this.data.taskId) {
      this.taskId = this.data.taskId
      console.log('[taskDetail] taskId extracted =', this.taskId)
    }
  },
  mounted() {
    console.log('[taskDetail] mounted, taskId =', this.taskId)
    this.loadDetail()
  },
  methods: {
    _closed() {
      // 底层内置方法 误删
      this.onclosed()
    },
    _cancle() {
      // 底层内置方法 误删
      console.log('[taskDetail] _cancle called')
      this.visible = false
      this.cancle && this.cancle()
    },
    handleClose() {
      // 保持兼容，也调用_cancle
      this._cancle()
    },
    async loadDetail() {
      console.log('[taskDetail] loadDetail called, taskId =', this.taskId)
      if (!this.taskId) {
        console.warn('[taskDetail] taskId is empty, skip loadDetail')
        return
      }
      const res = await this.$lgh.get('api/clean/task/info', {
        taskId: this.taskId
      })
      console.log('[taskDetail] API response =', res)
      // $lgh.get returns the result object directly
      this.task = res.task || res
      this.images = res.images || []
      if (this.task.locationInfo) {
        this.standardImageUrl = this.task.locationInfo.standard_image_url
      }
      console.log('[taskDetail] loadDetail complete, task =', this.task)
    },
    getStatusType(status) {
      const map = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger',
        5: 'warning',
        6: 'success',
        7: 'danger'
      }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = {
        0: '已打卡未提交',
        1: '已提交待审核',
        2: 'AI审核通过',
        3: 'AI审核不通过',
        5: '申诉中',
        6: '申诉通过',
        7: '申诉不通过'
      }
      return map[status] || '未知'
    },
    async triggerAiAudit() {
      this.triggerLoading = true
      try {
        await this.$lgh.get('api/clean/task/trigger-ai-audit', {
          taskId: this.taskId
        })
        this.$message.success('已触发AI审核，结果将在后台异步处理完成后更新')
        setTimeout(() => {
          this.loadDetail()
        }, 1000)
      } catch (err) {
        this.$message.error(err.message || '触发AI审核失败')
      } finally {
        this.triggerLoading = false
      }
    }
  }
}
</script>

<style scoped>
.detail-item {
  padding: 8px 0;
}
.detail-item .label {
  font-weight: bold;
  color: #606266;
}
.text-green {
  color: #67c23a;
  font-weight: bold;
}
.text-red {
  color: #f56c6c;
  font-weight: bold;
}
.card-header {
  font-weight: bold;
}
.image-container {
  text-align: center;
}
.detail-image {
  max-width: 100%;
  height: 200px;
  object-fit: contain;
  border-radius: 4px;
}
.image-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}
.image-item {
  text-align: center;
}
.margin-top {
  margin-top: 16px;
}
.dialog-footer {
  text-align: right;
}
</style>
